/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IObjectQueryScope extends angular.IScope {
        model: models.ObjectQueryModel
    }

    export class ObjectQueryController implements IController {

        constructor(
            private scope: IObjectQueryScope,
            qService: angular.IQService,
            growl: angular.growl.IGrowlService,
            $routeParams: angular.route.IRouteParamsService,
            systemLevelService: services.SystemLevelService,
            treeService: services.TreeService,
            objectQueryService: services.ObjectQueryService) {
            this.scope.model = new models.ObjectQueryModel(scope, qService, growl, $routeParams, systemLevelService, treeService, objectQueryService);
        }
    }
}

warsApp.registerController("ObjectQueryController", ["$scope", "$q", "growl", "$routeParams", "systemLevelService", "treeService", "objectQueryService"]);